var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-space-around"
  }, [_vm.showLoopToggle ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.disabled,
      "title": _vm.loop ? 'Loop on' : 'Loop off'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle-loop');
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.loop ? 'mdi-repeat' : 'mdi-repeat-off'))])], 1) : _vm._e(), _vm.showSkipButtons ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.frame === 0 || _vm.disabled || _vm.playing
    },
    on: {
      "click": function ($event) {
        _vm.frame = 0;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-backward")])], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.frame === 0 || _vm.disabled || _vm.playing
    },
    on: {
      "click": function ($event) {
        _vm.frame--;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-step-backward")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit(_vm.playing ? 'pause' : 'play');
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.playing ? 'mdi-pause' : 'mdi-play'))])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.frame === _vm.maxFrame || _vm.disabled || _vm.playing
    },
    on: {
      "click": function ($event) {
        _vm.frame++;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-step-forward")])], 1), _vm.showSkipButtons ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.frame === _vm.maxFrame || _vm.disabled || _vm.playing
    },
    on: {
      "click": function ($event) {
        _vm.frame = _vm.maxFrame;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-forward")])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }